/* Uniiq editorial blog template: TOC build + scroll-spy, copy-link, FAQ accordion. */
(function () {
  var root = document.querySelector('.article-editorial');
  if (!root) return;

  var prose = root.querySelector('.article-editorial__prose');
  var tocNav = root.querySelector('[data-ae-toc]');
  function slugify(t) {
    return t.toLowerCase().trim()
      .replace(/[^\wÀ-ɏ\s-]/g, '')
      .replace(/\s+/g, '-').replace(/-+/g, '-');
  }
  if (prose && tocNav) {
    var headings = prose.querySelectorAll('h2, h3');
    var used = {}, items = [];
    headings.forEach(function (h) {
      if (!h.textContent.trim()) return;
      var base = h.id || slugify(h.textContent) || 'section';
      var id = base, n = 1;
      while (used[id]) { n++; id = base + '-' + n; }
      used[id] = true; h.id = id;
      var anchor = document.createElement('a');
      anchor.href = '#' + id; anchor.className = 'ae-anchor';
      anchor.setAttribute('aria-hidden', 'true'); anchor.textContent = '#';
      h.appendChild(anchor);
      items.push({ id: id, text: h.textContent.replace(/#$/, '').trim(), level: h.tagName === 'H3' ? 3 : 2 });
    });
    if (items.length) {
      var ul = document.createElement('ul');
      items.forEach(function (it) {
        var li = document.createElement('li');
        if (it.level === 3) li.className = 'lvl-3';
        var a = document.createElement('a');
        a.href = '#' + it.id; a.textContent = it.text; a.dataset.target = it.id;
        li.appendChild(a); ul.appendChild(li);
      });
      tocNav.appendChild(ul);
      ul.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a) return;
        e.preventDefault();
        var el = document.getElementById(a.dataset.target);
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', '#' + a.dataset.target); }
      });
      var links = ul.querySelectorAll('a'), byId = {};
      links.forEach(function (l) { byId[l.dataset.target] = l; });
      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              links.forEach(function (l) { l.classList.remove('is-active'); });
              if (byId[en.target.id]) byId[en.target.id].classList.add('is-active');
            }
          });
        }, { rootMargin: '-12% 0px -70% 0px' });
        headings.forEach(function (h) { spy.observe(h); });
      }
    }
  }

  var copyBtn = root.querySelector('[data-ae-copy]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(copyBtn.dataset.url || window.location.href).then(function () {
        copyBtn.classList.add('is-copied');
        setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2000);
      });
    });
  }

  var faqWrap = root.querySelector('[data-ae-faq]');
  if (faqWrap) {
    var details = faqWrap.querySelectorAll('details');
    function closeD(d) {
      var body = d.querySelector('.accordion__body');
      if (body) { body.style.maxHeight = body.scrollHeight + 'px'; body.offsetHeight; body.style.maxHeight = '0'; body.style.overflow = 'hidden'; }
      d.classList.remove('is-active');
      setTimeout(function () { d.removeAttribute('open'); if (body) { body.style.maxHeight = ''; body.style.overflow = ''; } }, 300);
    }
    function openD(d) {
      d.setAttribute('open', ''); d.classList.add('is-active');
      var body = d.querySelector('.accordion__body'); if (!body) return;
      var h = body.scrollHeight; body.style.maxHeight = '0'; body.style.overflow = 'hidden'; body.offsetHeight; body.style.maxHeight = h + 'px';
      setTimeout(function () { body.style.maxHeight = ''; body.style.overflow = ''; }, 300);
    }
    details.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = d.hasAttribute('open');
        details.forEach(function (o) { if (o !== d && o.hasAttribute('open')) closeD(o); });
        if (isOpen) closeD(d); else openD(d);
      });
    });
  }
})();
